import { trim } from 'src/app/utils/string.utils';

export function toNumber(value: string): number {
    const formattedValue = trim(value);
    if (!formattedValue && '' + value !== '0') {
        return NaN;
    }
    const number = ('' + value).replace(',', '.');
    return +number;
}

export function toDoubleDigit(n: number): number {
    return Math.round(n * 100) / 100;
}

export function toGps(n: number): string {
    if (!n) {
        return null;
    }
    return n.toFixed(12);
}

export function getNumberRangeToFilters(rangeNumber: { startNumber?: number, endNumber?: number }): { start?: number, end?: number, operator: string } {
    const {startNumber = null, endNumber = null} = rangeNumber ?? {};

    let operator = '=';
    let start = startNumber === null ? null : +startNumber;
    let end   = endNumber   === null ? null : +endNumber;

    if (startNumber > 0 && endNumber > 0) {
        operator = 'Entre';
    } else if (endNumber > 0) {
        start = +endNumber;
        end = null;
        operator = '<=';
    } else if (startNumber > 0) {
        start = +startNumber;
        end = null;
        operator = '>=';
    }
    return {start, end, operator};
}

export function isInteger(id: string | number): boolean {
    return !!+id && Number.isInteger(+id);
}

export function toPercentage(amount: number): number{
    return amount * 100;
}
